module.exports = __webpack_public_path__ + "static/images/plus.136a7756923cca518c5dc6207f9a4f33.svg";